import api from "@/api";

export async function loadBaranjaAPI() {
  try {
    const res = await api.get("/baranja/list");
    return res.data;
  } catch (err) {
    console.error("Грешка при вчитување барања:", err);
    return [];
  }
}